<template>
<CRow>
    <CCol col="12">
        <ValidationObserver tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
        <CForm method="post" @submit.prevent="handleSubmit(submit)">
            <span class="badge badge-danger p-2 w-100 mb-2">{{ errMessage }}</span>

            <CRow>
                <CCustomInput
                    sm="12"
                    vid="title"
                    :name="$t('promotion.title')"
                    rules="required"
                    required
                    v-model="promotion.title"
                />

                <CCustomInput
                    sm="12"
                    vid="href"
                    :name="$t('promotion.href')"
                    rules="required|url"
                    required
                    ltr
                    v-model="promotion.href"
                />
            </CRow>

            <CRow class="mt-3">
                <CCol sm="12">
                    <label class="d-block">
                        <span>{{ $t('promotion.upload_banner') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                </CCol>
                <CCol sm="12" md="4" class="align-self-center mb-3" v-bind:key="index" v-for="(image, index) in images">
                    <ValidationProvider
                        tag="div"
                        :vid="'image_'+image.width+'_'+image.height"
                        :name="$t('promotion.image')"
                        :rules="imagesRules(image)"
                        v-slot="{ errors, validate }"
                    >
                        <CImageInputFile
                            @change="onChangeSrc($event, validate, image)"
                        >
                            <template #card-body>
                                <div><span>{{ image.height }}</span> <FaIcon icon="times" /> <span>{{ image.width }}</span></div>
                                <div><FaIcon v-if="image.is_desktop" icon="desktop" class="mx-1" /><FaIcon v-if="image.is_mobile" icon="mobile-alt" class="mx-1" /></div>
                            </template>
                            <template #invalid-feedback>
                                <span class="text-center invalid-feedback d-block">{{ errors[0] }}</span>
                            </template>
                            <template #after-card-body>
                                <CProgress
                                    :value="image.uploadPercent"
                                    height="5px"
                                />
                            </template>
                        </CImageInputFile>
                    </ValidationProvider>
                </CCol>
            </CRow>
            <CButton :disabled="invalid || imagesLength === 0" type="submit"  color="primary" class="px-4">{{ $t('submit') }}</CButton>
        </CForm>
        </ValidationObserver>
    </CCol>
</CRow>
</template>

<script>
import { getFirstOfArray } from '@/common/arrays'
import CImageInputFile from '@/components/form/CImageInputFile'
import { uploadService } from '@/services/api'

export default {
    name: 'SetupPromotionForm',

    components: {
        CImageInputFile,
    },

    props: {
        submit: {
            default: function () {},
            type: Function
        },
        promotion: {
            required: true,
        }
    },

    data() {
        return {
            errMessage: '',

            imagesLength: 0,
            images: [
                {
                    name: '300_250',
                    width: 300,
                    height: 250,
                    is_mobile: 1,
                    is_desktop: 1,
                    uploadPercent: 0,
                },
                {
                    name: '728_90',
                    width: 728,
                    height: 90,
                    is_mobile: 0,
                    is_desktop: 1,
                    uploadPercent: 0,
                },
                {
                    name: '970_250',
                    width: 970,
                    height: 250,
                    is_mobile: 0,
                    is_desktop: 1,
                    uploadPercent: 0,
                },
                {
                    name: '120_600',
                    width: 120,
                    height: 600,
                    is_mobile: 0,
                    is_desktop: 1,
                    uploadPercent: 0,
                },
                {
                    name: '300_100',
                    width: 300,
                    height: 100,
                    is_mobile: 1,
                    is_desktop: 0,
                    uploadPercent: 0,
                },
            ]
        }
    },

    watch: {
        'promotion.title': function(newVal) {
            this.promotion.alt_tag = newVal
        }
    },

    computed: {
        //
    },

    methods: {
        calcImagesLength() {
            return Object.keys(this.promotion.images).length
        },
        onChangeSrc(event, validate, image) {
            image.uploadPercent = 0

            validate(event).then((result) => {
                if(!result.valid) {
                    return
                }

                const data = {
                    file: getFirstOfArray(event.target.files)
                }

                uploadService.doUpload(data, 'promotion', (percent) => {
                    image.uploadPercent = percent
                }).then((response) => {
                    this.promotion.images[image.name] = response.data
                    this.imagesLength = this.calcImagesLength()
                })
            })
        },
        imagesRules(image) {
            return { image: true, dimensions: [image.width, image.height] }
        },
    }
}
</script>